export abstract class LanguageProvider {
  abstract getLanguage(overrideReportLanguage?: boolean): string;

  abstract setReportLanguage(reportLanguage: string): void;
}
